/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * Completion payload for a single-part upload.
 * @export
 * @interface SinglePartAssetUploadCompletion
 */
export interface SinglePartAssetUploadCompletion {
    /**
     * Opaque ETag value returned by S3 for a successful upload.
     * @type {string}
     * @memberof SinglePartAssetUploadCompletion
     */
    eTag: string;
}


/**
 * Check if a given object implements the SinglePartAssetUploadCompletion interface.
 */
export function instanceOfSinglePartAssetUploadCompletion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "eTag" in value;
    return isInstance;
}

export function SinglePartAssetUploadCompletionFromJSON(json: any): SinglePartAssetUploadCompletion {
    return SinglePartAssetUploadCompletionFromJSONTyped(json, false);
}

export function SinglePartAssetUploadCompletionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SinglePartAssetUploadCompletion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'eTag': json['eTag'],
    };
}

export function SinglePartAssetUploadCompletionToJSON(value?: SinglePartAssetUploadCompletion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'eTag': value.eTag,
    };
}

